<template>
    <div class="authentication-container" >
        <div class="page-info-header">
            <div class="page-info-header-label flex-align-center">
                <efly-tooltip content="返回" top="34px" left="-15px" placement="bottom" type="white" style="display:inline-block;" v-if="status.type !== 'person'" >
                    <efly-button class="page-info-header-back-btn btn-primary" @click="back()">
                        <i class="icon icon-goback"></i>
                    </efly-button>
                </efly-tooltip>
                <i class="icon color-primary icon-ID" v-else></i>
                <span class="mar-l-mini text-color-regular">{{status.type === 'person' ? '实名认证' : '升级企业用户'}} </span>
            </div>
        </div>

        <div class="authentication-content">
            <div class="authentication-block">
                <div class="tips mar-b-default">
                    <p class="color-danger">为避免影响您的资源购买及服务使用，请您尽快前往实名认证小程序完成实名验证。 实名验证过程中需注意以下事项：</p>
                    <p class="color-danger">● 在线实名失败3次后，后续每12小时内只能进行1次认证。</p>
                    <p class="color-danger">● 用户的真实姓名必须与安全手机号码所属用户的姓名一致，否则实名认证失败。</p>
                </div>
                <div class="QRcode-content box">
                    <div class="QRcode-top box" style="text-align: center">
                        <p class="QRcode-top-title"><i class="icon icon-css icon-scan"></i>打开微信扫码，立即实名</p>
                        <img class="QRcode-top-img" :src="imgPrefix+'/common/GetStaticPic?path='+qrcodeSrc" alt="" width="180px" height="180px" v-if="status.code === 'havedata'">
                        <div class="QRcode-top-img-loading box" v-if="status.code === 'loading'">
                            <img :src="$loadingImg" alt="">
                        </div>
                        <p>实名认证小程序</p>
                    </div>
                    <div class="QRcode-step">
                        <p class="QRcode-step-title">实名流程：</p>
                        <p class="QRcode-step-text">1、扫码进入实名认证小程序，授权登录。若您已登录，则立即进入实名认证。</p>
                        <p class="QRcode-step-text">2、实名步骤：填写实名信息->上传照片->录制视频。</p>
                        <p class="QRcode-step-text">3、如需要通过“被授权人”信息进行企业实名，请下载<a class="color-primary line-hover" style="cursor:pointer;" @click="skipHelpDoc()">《授权书模板》</a>。</p>
                        <!-- <p class="QRcode-step-help" @click="linktoDocPage('/help/AccountDoc')">查看更多实名帮助 ></p> -->
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import Authentication from './authentication'
export default Authentication;
</script>

<style lang="scss" scoped>
    .authentication-container {
        width: 100%;
        background-color: rgb(241, 244, 248);
    }
    .authentication-content {
        padding: 20px;
    }
    .authentication-block {
        background: #fff;
        padding: 20px;
    }

    .QRcode-content{
        flex-direction: column;
        width: 720px;
        border: 1px solid #eff1f5;
    }

    .QRcode-top{
        align-items: center;
        flex-direction: column;
        padding: 30px;
        background: #f9f9f9;
        border-bottom: 1px solid #eff1f5;
    }

    .QRcode-top-title {
        font-size: 16px;
    }

    .QRcode-top-title > .icon {
        font-size: 16px !important;
        margin-right: 10px;
    }

    .QRcode-top-img {
        width: 160px;
        height: 160px;
        margin: 20px;
        border-radius: 100px;
        border: 1px solid #e7e7e7;
    }

    .QRcode-top-img-loading{
        align-items: center;
        justify-content: center;
        margin: 20px;
        width: 180px;
        height: 180px;
    }

    .QRcode-step {
        padding: 20px;
    }

    .QRcode-step-title {
        color: #333;
        font-weight: bold;
    }

    .QRcode-step-text {
        margin-top: 15px;
        color: #555;
    }

    .QRcode-step-help {
        margin-top: 15px;
        color: #4a7ee9;
        cursor: pointer;
    }
    .line-hover:hover {
        text-decoration: underline;
    }
</style>